import React, { useState } from 'react'
import Select from 'react-select';
import { Barcode } from './Barcode';
import { useRef } from 'react';
import PeticionTraeDatos from '../../hooks/useTraeDatos';
import { useEffect } from 'react';
const ProductosSeleccionadosConfiguracion = ({ productosSeleccionados }) => {
    const baseUrl = process.env.REACT_APP_BASE_URL
    const api = process.env.REACT_APP_API
    const urlConfiguraciones = baseUrl + api + 'configuraciones/'
    const [config] = PeticionTraeDatos(urlConfiguraciones)

    const barcodeRef = useRef()
    const [datosPagina, setDatosPagina] = useState({
        altoSticker: 22.7541638,
        anchoSticker: 53.1812433,
        tamanoProducto: 3.4395829,
        tamanoNumero: 3.4395829,
        anchoHoja: 160.0728965,
        barcode: 5.291666,
        copias: 1
    })

    useEffect(() => {
        if (config && config.length > 0) {
            setDatosPagina(JSON.parse(config[15].valor))
        }
    }, [config])


    const imprimir = () => {
        barcodeRef.current.handlePrintButton()
    }

    const cambiarDatosPagina = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        setDatosPagina({ ...datosPagina, [name]: parseFloat(value) })
    }

    return (
        <>
            <div className="row">
                <div className="col-md-5">
                    <div className='row'>

                        <div className='form-group col-12'>
                            <h5 className='font-weight-normal'>Tamaño de Sticker (mm):</h5>
                            <div className="row">
                                <div className='form-group col-4'>
                                    <input type="number" step="1" name="altoSticker" className="form-control" placeholder='Alto' onChange={cambiarDatosPagina} value={datosPagina.altoSticker} />
                                </div>
                                <div className='form-group col-4'>
                                    <input type="number" step="1" name="anchoSticker" className="form-control" placeholder='Ancho' onChange={cambiarDatosPagina} value={datosPagina.anchoSticker} />
                                </div>
                                <div className='form-group col-4'>
                                    <input type="number" step="1" name="barcode" className="form-control" placeholder='Tamaño Barcode' onChange={cambiarDatosPagina} value={datosPagina.barcode} />
                                </div>
                            </div>
                        </div>
                        <div className='form-group col-12'>
                            <h5 className='font-weight-normal'>Fuente Codigo (mm):</h5>
                            <div className="row">
                                <div className='form-group col-6'>
                                    <input type="number" step="0.01" name="tamanoProducto" className="form-control" placeholder='Tamaño producto' onChange={cambiarDatosPagina} value={datosPagina.tamanoProducto} />
                                </div>
                                <div className='form-group col-6'>
                                    <input type="number" step="0.01" name="tamanoNumero" className="form-control" placeholder='Tamaño numero' onChange={cambiarDatosPagina} value={datosPagina.tamanoNumero} />
                                </div>
                            </div>
                        </div>
                        <div className='form-group col-12'>

                            <div className="row">

                                <div className='form-group col-md-6'>
                                    <h5 className='font-weight-normal'>Ancho de la hoja:</h5>
                                    <input type="number" step="0.01" name="anchoHoja" className="form-control" placeholder='50' onChange={cambiarDatosPagina} value={datosPagina.anchoHoja} />
                                </div>
                                <div className='form-group col-md-6'>
                                    <h5 className='font-weight-normal'>Copias:</h5>
                                    <input type="number" step="1" name="copias" className="form-control" placeholder='1' onChange={cambiarDatosPagina} value={datosPagina.copias} />
                                </div>
                            </div>
                        </div>


                        <div className='form-group col-12'>
                            <h5 className='font-weight-normal'>Numero de Productos a Imprimir: {`(${productosSeleccionados.length})`}</h5>
                        </div>
                        <div className='form-group col-12'>
                            <button className='btn float-right  btn-seleccionar-hoja-productos' onClick={imprimir}>
                                Imprimir
                            </button>
                        </div>
                    </div>

                </div>
                <div className="col-md-7">
                    <Barcode productosSeleccionados={productosSeleccionados} ref={barcodeRef} datosPagina={datosPagina} />
                </div>
            </div>

        </>
    )
}

export default ProductosSeleccionadosConfiguracion